import { gql } from '@apollo/client';

export const FETCH_ALL_VIRTUAL_VISIT_QUERY = gql`
  query fetchUpCommingAppointments {
    fetchUpCommingAppointments {
      appointmentResource
      docArn
    }
  }
`;
export const FETCH_UPCOMING_BILLS_QUERY = gql`
  query billSummary {
    billSummary {
      totalDue
      totalSpent
    }
  }
`;
export const FETCH_UPCOMING_CONSENTS_QUERY = gql`
  query fetchUpcommingConsents {
    fetchUpcommingConsents {
      upComingConsentResourceList
      consentType
      accepted
    }
  }
`;
